const upgradePersonal = {
  bannerTitle: 'HitPaw Online Ultimate',
  introduct:
    'Krijg premium voordelen voor meer dan 35 functies, waaronder versterkers, verwijderaars, AI -vertalers, schermrecorders en meer. Krijg het allemaal tegen één betaalbare prijs.',
  Upgrade: 'Upgrade',
  Tools: 'Hulpmiddelen',
  MyProjects: 'Mijn projecten',
  MyAccount: 'Mijn rekening',
  Subscription: 'Abonnement',
  LogOut: 'Uitloggen',
  PopularTools: 'Populaire tools',
  Enhance: 'Uitbreiden',
  Remove: 'Verwijderen',
  Animate: 'Animeren',
  Extract: 'Extract',
  SaveThreeDays:
    'Projecten worden 3 dagen opgeslagen, download ze na het verwerken.',
  All: 'Alle',
  Video: 'Video',
  Image: 'Afbeelding',
  Audio: 'Audio',
  minutesAgo: 'minuten geleden',
  hoursAgo: 'uren geleden',
  daysAgo: 'dagen geleden',
  Modified: 'Aangepast',
  Order: 'Volgorde',
  EarliestToLatest: 'Vroegst naar het laatste',
  LatestToEarliest: 'Nieuwste tot vroegste',
  NoProject: 'Nog geen project. Snel begin met',
  OnlineTools: 'Online tools',
  AIVideoEnhancer: 'AI Video Enhancer',
  Enhancer4K: "One-klik naar AI Verbeter video's tot 4k online",
  AIPhotoEnhancer: 'AI Photo Enhancer',
  AIEnhancerImage: 'AI Verbeter afbeeldingen loslietig tot 8x online',
  View: 'Weergave',
  Download: 'Downloaden',
  MultipleSelect: 'Multiple-selecteren',
  Delete: 'Verwijderen',
  SubscriptionHistory: 'Abonnementsgeschiedenis',
  NoValidSubscription: 'Geen geldig abonnement.',
  veContent: "Met één klik kunt u video's via AI online verbeteren tot 4K",
  peContent: 'AI verbetert afbeeldingen verliesloos tot 8x online',
  rmvContent: 'Watermerk uit video verwijderen',
  rmttContent: 'Verwijder TikTok-videowatermerken in een oogwenk',
  dynamicContent: 'Animeer uw foto online',
  rmbgContent: 'Verwijder de achtergrond van de afbeelding',
  youMayNeed: 'Je zou nodig kunnen hebben',
  new: 'Nieuw',
  loginYourAccount: 'Log in op uw HitPaw-account',
  signUpYourAccount: 'Meld u aan bij uw HitPaw-account',
  HitPawWatermark: 'Watermark Remover',
  HitPawTiktokWatermark: 'TikTok Watermark Remover',
  HitPawRemoveBg: 'Background Remover',
  dynamicTitle: 'HitPaw Online Animate Old Photos',
};
export default upgradePersonal;
